import useApartmentBuildingAreaMinMax from 'api/hooks/use-apartment-building-area-limits';
import useTypesBuildingByComplexId from 'api/hooks/use-types-building-by-id';
import { useEffect, useState } from 'react';

const useTypes = (selectedComplexBuilding: number | null) => {
  const [selectedTypesApartment, setSelectedTypesApartment] = useState<number | null>(null);
  const [isMount, setIsMount] = useState(true);

  const {
    types: typesApartment,
    isLoading: isLoadingTypes,
    error: errorTypes,
  } = useTypesBuildingByComplexId(selectedComplexBuilding, true);

  const handleSetTypesApartment = (type: number) => {
    setSelectedTypesApartment(type);
  };

  const handleResetTypesApartment = () => {
    setSelectedTypesApartment(null);
  };

  useEffect(() => {
    if (errorTypes) {
      console.log(errorTypes);
    }
  }, [errorTypes]);

  const {
    minMaxArea,
    isLoading: isLoadingMinMaxArea,
    isValidating: isValidatingMinMaxArea,
    mutate,
  } = useApartmentBuildingAreaMinMax(selectedComplexBuilding, selectedTypesApartment);

  useEffect(() => {
    if (isMount) {
      setIsMount(false);
    } else {
      mutate();
    }
  }, [selectedComplexBuilding, selectedTypesApartment]);

  const isLoadingMinMax = isLoadingMinMaxArea || isValidatingMinMaxArea;

  return {
    typesApartment,
    minMaxArea,
    selectedTypesApartment,
    isLoadingTypes,
    isLoadingMinMax,
    handleSetTypesApartment,
    handleResetTypesApartment,
  };
};
export default useTypes;
